import template from './diversificationIntegrations.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    opportunity: '<',
    diversificationOpportunities: '<',
    diversificationOpportunitiesComments: '<',
    contacts: '<',
    ticketClientTypes: '<',
    addresses: '<',
    ticket: '<',
    loan: '<',
    owner: '<',
    ticketValue: '<',
    idTicket: '<',
    idWorkflow: '<',
    idContact: '<',
    idAli: '<',
    isTicket: '<',
    onFinished: '&',
    onCommentsFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdDialog,
      $mdMedia,
      diversificationIntegrationService,
      OpportunitySelectionType
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.isOpenDialog = false;
      ctrl.$mdMedia = $mdMedia;

      ctrl.initialize = () => {
        ctrl.opportunity = ctrl.opportunity || null;
        ctrl.contacts = ctrl.contacts || [];
        ctrl.person = _.find(ctrl.contacts, (c) => !c?.isCompany);
        ctrl.ticketClientTypes = ctrl.ticketClientTypes || [];
        ctrl.addresses = ctrl.addresses || [];
        ctrl.ticket = ctrl.ticket || {};
        ctrl.loan = ctrl.loan || {};
        ctrl.owner = ctrl.owner || {};
        ctrl.ticketValue = ctrl.ticketValue || 0;
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.idOwner = ctrl.idOwner || ctrl.owner.id || '';
        ctrl.idWorkflow = ctrl.idWorkflow || '';
        ctrl.idContact = ctrl.idContact || '';
        ctrl.idAli = ctrl.idAli || '';
        ctrl.isTicket = ctrl.isTicket || false;

        ctrl.availableByType = diversificationIntegrationService.getAvailableByType({
          owner: ctrl.owner,
          opportunityType: ctrl.isTicket
            ? ctrl.opportunity?.typeContextual?.type
            : ctrl.opportunity?.type?.name
        });
      };

      ctrl.isDeclined = () =>
        ctrl.opportunity?.selection?.name === OpportunitySelectionType.declined.name;

      ctrl.myConnectFinished = (result) => {
        if (ctrl.isTicket) {
          ctrl.onFinished({ integration: 'MY_CONNECT', result });
        }
      };

      ctrl.movingHubFinished = (result) => {
        if (ctrl.isTicket) {
          ctrl.onFinished({ integration: 'MOVING_HUB', result });
        }
      };

      ctrl.aliFinished = (result) => {
        if (ctrl.isTicket) {
          ctrl.onFinished({ integration: 'ALI', result });
        }
      };

      ctrl.getOpportunityType = () =>
        ctrl.isTicket ? ctrl.opportunity?.typeContextual?.type : ctrl.opportunity?.type?.name;

      ctrl.show = ({ integration }) => {
        const opportunityType = ctrl.isTicket
          ? ctrl.opportunity?.typeContextual?.type
          : ctrl.opportunity?.type?.name;

        return diversificationIntegrationService.isIntegrationEnabled({
          opportunityType,
          integration,
          owner: ctrl.owner
        });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
